module.exports = __webpack_public_path__ + "static/media/gim1.c66cf946.jpg";